/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Error_Future_DateInputs */

const en_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose today or a future date.`)
};

const de_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie das heutige oder ein zukünftiges Datum.`)
};

const fr_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez aujourd’hui ou une date future.`)
};

const es_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige hoy o una fecha futura.`)
};

const it_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli oggi o una data futura.`)
};

const nl_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies vandaag of een toekomstige datum.`)
};

const pl_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz dzisiejszą lub przyszłą datę.`)
};

const fi_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse tämä päivä tai tuleva päivä.`)
};

const da_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg i dag eller en fremtidig dato.`)
};

const sv_consumer_declaration_error_future_date = /** @type {(inputs: Consumer_Declaration_Error_Future_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj i dag eller ett framtida datum.`)
};

/**
* | output |
* | --- |
* | "Choose today or a future date." |
*
* @param {Consumer_Declaration_Error_Future_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_error_future_date = /** @type {((inputs?: Consumer_Declaration_Error_Future_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Error_Future_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_error_future_date(inputs)
	if (locale === "fr") return fr_consumer_declaration_error_future_date(inputs)
	if (locale === "es") return es_consumer_declaration_error_future_date(inputs)
	if (locale === "it") return it_consumer_declaration_error_future_date(inputs)
	if (locale === "nl") return nl_consumer_declaration_error_future_date(inputs)
	if (locale === "pl") return pl_consumer_declaration_error_future_date(inputs)
	if (locale === "fi") return fi_consumer_declaration_error_future_date(inputs)
	if (locale === "da") return da_consumer_declaration_error_future_date(inputs)
	if (locale === "sv") return sv_consumer_declaration_error_future_date(inputs)
	return en_consumer_declaration_error_future_date(inputs)
});